import type { App } from 'vue';
import { useFullPage } from './full-page/f-full-page-layout';

export declare interface Layouts {
  install: (app: App) => void;
}

export function useLayouts() : Layouts {
  return {
    install: (app: App) => {
      app.use(useFullPage());
    },
  };
}